import styled from "styled-components";
import { fadeIn, fadeInUp } from '../../styles/Animations';

export const FormContainer = styled.div`
  max-width: 1100px;
  padding: 4em 0;
  background-color: #F2F2F2;
  margin: 0 auto;
  animation: ${fadeIn} 1s ease-out;

  @media (max-width: 550px) {
    /* Phones */
    padding: 2em;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    padding: 2em;
  }

  input[type="text"],
  input[type="email"],
  input[type="tel"]{
    font-size: 1em;
  }

  input[type="checkbox"]{
    margin-right: 0.5em;
  }

  input[type="email"]{
    @media (max-width: 550px) {
    /* Phones */
    font-size: 0.9em;
    width: 110%;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 0.9em;
    flex-direction: column;
    width: 100%;
  }
  }
`;

export const Title = styled.h2`
  font-size: 2.5em;
  font-weight: bold;
  animation: ${fadeInUp} 1s ease-out;

  @media (max-width: 550px) {
    /* Phones */
    font-size: 2em;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 2em;
  }
`;

export const Subtitle = styled.p`
  color: gray;
  animation: ${fadeInUp} 1s ease-out 0.2s backwards;
`;

export const Label = styled.label`
  display: block;
  margin: 10px 0 5px;
  font-weight: bold;
  text-transform: uppercase;
`;

export const Input = styled.input`
  width: 100%;
  padding: 15px 20px;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  background-color: #E7E7E7;
`;

export const InputCountry = styled.input`
  width: 110%;
  padding: 15px 20px;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  background-color: #E7E7E7;

  @media (max-width: 550px) {
    /* Phones */
    font-size: 0.9em;
    width: 110%;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 0.9em;
    flex-direction: column;
    width: 110%;
  }
`;

export const FileInput = styled.button`
  width: fit-content ;
  display: flex;
  align-items: center;
  align-self: flex-end;
  background-color: none;
  color: rgba(234, 11, 42, 1);
  border: 1px solid rgba(234, 11, 42, 1);
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;
  animation: ${fadeInUp} 1s ease-out 0.4s backwards;
  transition: all 0.3s ease;

  p{
    margin-left: 5px;
  }

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    color: white;
    transform: translateY(-2px);
  }
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  margin-top: 10px;
  font-size: 14px;
  margin-bottom: 1.5em;
`;

export const SubmitButton = styled.button`
  align-self: flex-end;
  background-color: rgba(40, 44, 52, 1);
  color: rgb(255, 255, 255);
  border: 1px solid rgba(40, 44, 52, 1);
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;
  animation: ${fadeInUp} 1s ease-out 0.6s backwards;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    border: 1px solid rgba(234, 11, 42, 1);
    color: white;
    transform: translateY(-2px);
  }
`;

export const NameAndPhoneContainer = styled.div`
  display: flex;
  margin-top: 1em;
  justify-content: space-between;
  animation: ${fadeInUp} 1s ease-out 0.3s backwards;

  @media (max-width: 550px) {
    /* Phones */
    flex-direction: column;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    flex-direction: column;
  }
`
export const InputContainer = styled.div`
  width: 45%;
  margin-bottom: 1.5em;
  animation: ${fadeIn} 0.8s ease-out;

  @media (max-width: 550px) {
    /* Phones */
    font-size: 0.9em;
    width: 90%;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 0.9em;
    flex-direction: column;
    width: 90%;
  }
`

export const CVContainer = styled.div`
  margin-top: 1.5em;
  animation: ${fadeInUp} 1s ease-out 0.4s backwards;
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  animation: ${fadeInUp} 1s ease-out 0.5s backwards;
`
